import script from "./RightBar.vue?vue&type=script&setup=true&lang=js"
export * from "./RightBar.vue?vue&type=script&setup=true&lang=js"

import "./RightBar.vue?vue&type=style&index=0&id=12b62398&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12b62398"]])

export default __exports__